import { render } from "./ManageProductDialog.vue?vue&type=template&id=374c147d"
import script from "./ManageProductDialog.vue?vue&type=script&lang=js"
export * from "./ManageProductDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__